import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { configureNativeShell } from './lib/nativeShell';
import { initializeNativeScreenAwake } from './lib/nativeScreenAwake';
import { installVueCompatibility } from './lib/vueCompatibility';
import { auth, authPersistenceReady, db } from './firebaseConfig';
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc, updateDoc, deleteField, serverTimestamp, setDoc } from "firebase/firestore";
import {
  clearPushNotificationsForSignedOutUser,
  configurePushNotifications,
  syncPushNotificationsForUser,
} from './services/pushNotifications';
import {
  beginStoredSession,
  clearStoredSession,
  saveStoredRole,
} from './lib/authRoleCache';
import 'normalize.css/normalize.css';
import './assets/css/consolidated_backend.css';
import './assets/css/mobile-shell.css';
import './assets/css/staff-ui-refined.css';
import './assets/css/staff-controls-refined.css';
import './assets/css/staff-controls-aligned.css';

configureNativeShell();
initializeNativeScreenAwake();

const handleAuthStateChange = async (user) => {
  if (user) {
    // Non impostare un ruolo provvisorio: nelle nuove schede il router potrebbe
    // leggerlo prima del recupero del profilo e negare l'accesso allo staff.
    beginStoredSession(localStorage, user.uid);

    const pendingProfileJson = localStorage.getItem('pendingUserProfile');
    if (pendingProfileJson) {
      try {
        const pendingProfile = JSON.parse(pendingProfileJson);
        if (pendingProfile?.uid === user.uid) {
          await setDoc(doc(db, 'users', user.uid), {
            ...pendingProfile,
            created_time: serverTimestamp(),
          }, { merge: true });
          localStorage.removeItem('pendingUserProfile');
        }
      } catch (profileSyncError) {
        console.warn('Profilo utente ancora in attesa di sincronizzazione:', profileSyncError);
      }
    }

    try {
      const userDocRef = doc(db, "users", user.uid);
      const docSnap = await getDoc(userDocRef);
      const userRole = docSnap.exists() ? (docSnap.data().userRole || 'User') : 'User';
      saveStoredRole(localStorage, user.uid, userRole);
      console.log("Ruolo salvato:", userRole);
    } catch (roleError) {
      console.warn('Ruolo non ancora disponibile:', roleError);
    }
    await syncPushNotificationsForUser(user);
  } else {
    clearStoredSession(localStorage);
    await clearPushNotificationsForSignedOutUser();
  }
};

authPersistenceReady.then(() => {
  onAuthStateChanged(auth, handleAuthStateChange);
});

router.beforeEach(async (to, from, next) => {
  // Controllo per assistenzanutrizionale
  if (from.matched.some(record => record.path === '/assistenzanutrizionale/conversation/:ticketId') && from.params.ticketId) {
    try {
      await updateDoc(doc(db, 'assistenzanutrizionale', from.params.ticketId), {
        read: deleteField()
      });
      console.log("Campo 'read' rimosso per assistenzanutrizionale.");
    } catch (error) {
      console.error('Errore durante la rimozione del campo read per assistenzanutrizionale:', error);
    }
  }



  next();
});

const app = createApp(App).use(store).use(router);
installVueCompatibility(app);
configurePushNotifications(router).catch(error => {
  console.warn('Inizializzazione notifiche push non riuscita:', error);
});
app.mount('#app');
